import React from 'react';

function AmexIcon() {
  return (
    <svg
      width="45"
      height="31"
      viewBox="0 0 45 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.07"
        d="M41.4474 1.87891H3.55263C1.53947 1.87891 0 3.39557 0 5.37891V26.3789C0 28.3622 1.65789 29.8789 3.55263 29.8789H41.4474C43.4605 29.8789 45 28.3622 45 26.3789V5.37891C45 3.39557 43.3421 1.87891 41.4474 1.87891Z"
        fill="black"
      />
      <path
        d="M41.6111 2.87891C42.925 2.87891 44 3.94254 44 5.24254V26.5153C44 27.8153 42.925 28.8789 41.6111 28.8789H3.38889C2.075 28.8789 1 27.8153 1 26.5153V5.24254C1 3.94254 2.075 2.87891 3.38889 2.87891H41.6111Z"
        fill="#0071D6"
      />
      <path
        d="M10.6236 13.8583L11.5402 16.0469H9.71418L10.6236 13.8583ZM29.6598 13.9493H26.1344V14.9141H29.603V16.3596H26.1415V17.4353H29.6669V18.2974L32.1265 15.6783L29.6669 12.9483L29.6598 13.9493ZM13.0063 11.2193H17.7372L18.7876 13.4768L19.761 11.2123H32.0413L33.3179 12.6006L34.6383 11.2123H40.2787L36.1114 15.7063L40.236 20.1723H34.5115L33.235 18.7839L31.9027 20.1723H11.8777L11.2927 18.7839H9.95457L9.36839 20.1723H4.73694L8.62825 11.2123H12.6901L13.0063 11.2193ZM23.2651 12.4769H20.6137L18.8373 16.6023L16.913 12.4769H14.2817V18.0886L11.8422 12.4769H9.48207L6.66128 18.9076H8.50273L9.08773 17.5193H12.1619L12.7469 18.9076H15.968V14.3168L18.0415 18.9146H19.4508L21.5113 14.3308V18.9158H23.2379L23.2663 12.4758L23.2651 12.4769ZM34.3256 15.7063L37.3229 12.4769H35.1652L33.2693 14.4906L31.4362 12.4769H24.4564V18.9146H31.3367L33.248 16.8869L35.0812 18.9146H37.3015L34.3256 15.7063Z"
        fill="white"
      />
    </svg>
  );
}

export default AmexIcon;
